import React from "react";
import "./Scene.css";
import { useView } from "src/contexts/ViewContext";
import { useLoader } from "src/contexts/LoaderContext";
import LegendBox from "../LegendBox/LegendBox";

const Scene: React.FC = () => {
  const { is3DView } = useView();
  const { isSceneLoaderVisible, isWhiteSceneLoaderVisible } = useLoader();

  return (
    <div id="configurator-scene" className={is3DView ? "" : "map"}>
      {isWhiteSceneLoaderVisible && <div className="scene-white-loader"></div>}
      {isSceneLoaderVisible && <div className="scene-loader"></div>}
      <LegendBox />
    </div>
  );
};

export default Scene;
